import { render, staticRenderFns } from "./BudgetDetail.vue?vue&type=template&id=10d640b2&scoped=true"
import script from "./BudgetDetail.vue?vue&type=script&lang=js"
export * from "./BudgetDetail.vue?vue&type=script&lang=js"
import style0 from "./BudgetDetail.vue?vue&type=style&index=0&id=10d640b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d640b2",
  null
  
)

export default component.exports